import z from 'zod'
import {
  nullSafeBoolean,
  nullSafeFirestoreTimestamp,
  nullSafeNumber,
} from '../shared/schema'

export const schema = z.object({
  completed: nullSafeBoolean(false),
  createdAt: nullSafeFirestoreTimestamp(),
  price: nullSafeNumber(0),
  purchaseType: z.literal('stripeSession'),
  quantity: nullSafeNumber(0),
  updatedAt: nullSafeFirestoreTimestamp(),
  userId: z.string(),
})

export const writeSchema = schema.extend({})

export const empty = Object.freeze(
  schema.parse({
    completed: false,
    price: 0,
    purchaseType: 'stripeSession',
    quantity: 0,
    userId: '',
  })
)

export type FirestorePayment = z.infer<typeof schema>
